// extracted by mini-css-extract-plugin
export default {"errorWrap":"KhaZmgQA7UBIcCXsC0dh","icon":"_yUOwigFy7zZAQprzGug","title":"ZsEymYUJviWxJhNHuEMH","description":"pa1unSVxJ3MJWDA4aFbR","suggestion":"L9QNZIVl757_1U7jNLIw"};